<div class="update__wrapper">
  <div class="update__version">
    <span data-at-update-version>
      {{ '+UPDATES.VERSION.TITLE' | translate }} {{ update?.version }}
    </span>
  </div>

  <div *ngIf="update?.improvements" [class.update__divider]="update?.fixes">
    <span data-at-improvements-title class="update__title">
      {{ '+UPDATES.IMPROVEMENTS.TITLE' | translate }}
    </span>

    <ul>
      <ng-container *ngFor="let improvement of update.improvements">
        <li class="update__entry" *ngIf="improvement">
          {{ improvement }}
        </li>
      </ng-container>
    </ul>
  </div>

  <div *ngIf="update?.fixes" class="updates">
    <span data-at-fixes-title class="update__title">
      {{ '+UPDATES.FIXES.TITLE' | translate }}
    </span>

    <ul>
      <ng-container *ngFor="let fix of update.fixes">
        <li class="update__entry" *ngIf="fix">
          {{ fix }}
        </li>
      </ng-container>
    </ul>
  </div>
</div>
